import React from 'react';
import { classNames } from '@payfit/growth-platform-brand-system-v2/utils/style';
import Header from './Header';
import Calculation from './Calculation';
import Separator from './Separator';
import Subheader from './Subheader';
import Footer from './Footer';
import FreeMonths from './FreeMonth';

const PriceBreakdown = ({
  children,
  className,
}: {
  children: React.ReactNode;
  className?: string;
}) => {
  return (
    <div
      className={classNames(
        'PriceBreakdown',
        'flex flex-col gap-[16px] md:min-w-[358px]',
        'text-[#042040]',
        className,
      )}
    >
      {children}
    </div>
  );
};

PriceBreakdown.Header = Header;
PriceBreakdown.Subheader = Subheader;
PriceBreakdown.Separator = Separator;
PriceBreakdown.Calculation = Calculation;
PriceBreakdown.SecondCalculation = Calculation;
PriceBreakdown.Footer = Footer;
PriceBreakdown.FreeMonths = FreeMonths;

export default PriceBreakdown;
